import type { DataForEmail } from "./textFormatter";

/**
 * Extracts the product details from the form data.
 *
 * @param data The form data.
 * @returns The product details.
 * @throws TypeError If the product details cannot be extracted.
 */
export function extractProductDetails(data: FormData): DataForEmail {
	const notes = data.get("notes");
	if ("string" !== typeof notes) {
		throw new TypeError("Notes is not a string");
	}

	const product = document.getElementById(
		"rt-pspr-product-details",
	)?.textContent;

	if (!product) {
		throw new TypeError("Product is not a string");
	}
	const dataForEmail: DataForEmail = {
		details: new Map(),
		notes,
		product,
		properties: new Map(),
	};

	for (const [key, value] of Array.from(data.entries())) {
		if (key.includes("properties") && "string" === typeof value) {
			dataForEmail.properties.set(key, value);
		} else if (key.includes("details") && "string" === typeof value) {
			dataForEmail.details.set(key, value);
		}
	}
	return dataForEmail;
}
